import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon" }
const _hoisted_2 = ["href"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
	icon: {
		type: String,
		required: true
	}
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("use", {
      href: require('@/assets/icons/feather-sprite.svg') + `#${__props.icon}`
    }, null, 8, _hoisted_2)
  ]))
}
}

})